// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addresses-box .subtitle {
  font-weight: initial;
  font-size: 12px;
}

.input-form {
  margin: 0px;
}

.type-row {
  margin: 0;
  text-align: center;
  font-weight: bold;
}

.type-row.address {
  margin: 2px 0;
  padding: 5px;
  text-align: start;
  border-bottom: 1px solid var(--button-b-text);
}

.addresses-box {
  max-height: 225px;
  overflow: scroll;
}

.addresses-box::-webkit-scrollbar {
  display: none;
}

.slide-zoom {
  text-align: initial;
  font-size: initial;
}

.order-address-box .scroll-list .scroll-content {
  padding: 0;
}

.error {
  color: red;
  margin: 5px 0;
}

.swiper-slide {
  display: initial;
}

ion-list {
  background: none;
}

.radio-color {
  --border-radius: var(--text-a);
  --color: var(--text-a);
  --color-checked: var(--text-a);
}

.seperate-childs {
  display: flex;
  align-items: center;
  color: var(--ion-color-step-600, #666666) !important;
}
.seperate-childs .value:not(.hide-dot):before {
  content: "-";
  margin: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/cart/components/order-address/order-address.component.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;EACA,eAAA;AAAJ;;AAoBA;EACE,WAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;AAjBF;;AAqBA;EACE,aAAA;EACA,YAAA;EACA,iBAAA;EACA,6CAAA;AAlBF;;AA0CA;EACE,iBAAA;EACA,gBAAA;AAvCF;;AA2CA;EACE,aAAA;AAxCF;;AA2CA;EACE,mBAAA;EACA,kBAAA;AAxCF;;AA2CA;EACE,UAAA;AAxCF;;AA2CA;EACE,UAAA;EACA,aAAA;AAxCF;;AA2CA;EACE,gBAAA;AAxCF;;AA2CA;EACE,gBAAA;AAxCF;;AAoDA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;AAjDF;;AAoDA;EACE,aAAA;EACA,mBAAA;EACA,oDAAA;AAjDF;AAoDE;EACE,YAAA;EACA,aAAA;AAlDJ","sourcesContent":[".addresses-box {\n  .subtitle {\n    font-weight: initial;\n    font-size: 12px;\n  }\n}\n\n.order-address-box {\n  //background: var(--button-b-background);\n  //color: var(--button-b-text);\n  //background: #fff;\n  //color:#000;\n}\n\n.title {\n  //padding: 10px;\n  //text-align: center;\n  //background: #2e3842;\n  //color: #fff;\n  //font-weight: bold;\n  //line-height: 1;\n}\n\n.input-form {\n  margin: 0px;\n}\n\n.type-row {\n  margin: 0;\n  text-align: center;\n  font-weight: bold;\n  //font-size: 15px;\n}\n\n.type-row.address {\n  margin: 2px 0;\n  padding: 5px;\n  text-align: start;\n  border-bottom: 1px solid var(--button-b-text);\n}\n\n//\n//.type-row.address.off {\n//  opacity: 0.4;\n//}\n\n.type-row.address .checkbox-icon {\n  //font-size: 20px;\n}\n\n//\n//.type-row.address .title {\n//  background: none;\n//  text-align: start;\n//  padding: 0;\n//}\n//\n//.address .subtitle {\n//  font-weight: initial;\n//  font-size: 12px;\n//}\n\n.addresses-box {\n  max-height: 225px;\n  overflow: scroll;\n  //margin-bottom: 10px;\n}\n\n.addresses-box::-webkit-scrollbar {\n  display: none;\n}\n\n.slide-zoom {\n  text-align: initial;\n  font-size: initial;\n}\n\n.order-address-box .scroll-list .scroll-content {\n  padding: 0;\n}\n\n.error {\n  color: red;\n  margin: 5px 0;\n}\n\n.swiper-slide {\n  display: initial;\n}\n\nion-list {\n  background: none;\n}\n\nion-radio-group ion-item {\n  //--background: none;\n  //color: #fff;\n\n  ion-radio {\n    //--color-checked: var(--button-b-text)\n  }\n}\n\n.radio-color {\n  --border-radius: var(--text-a);\n  --color: var(--text-a);\n  --color-checked: var(--text-a);\n}\n\n.seperate-childs {\n  display: flex;\n  align-items: center;\n  color: var(--ion-color-step-600, #666666) !important;\n\n  // Target all children except the last one\n  .value:not(.hide-dot):before {\n    content: '-'; // Using the middle dot character\n    margin: 0 4px; // Adjust spacing around the dot as needed\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
